export default __webpack_public_path__ + "static/2017-b547af9d957c54757c26dc355d402943.png";